var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInkwell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 240.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#666;}.cls-1,.cls-2,.cls-3{stroke-width:2px;}.cls-1,.cls-2,.cls-3,.cls-4{fill:none;stroke-linecap:round;stroke-miterlimit:10;}.cls-2{stroke:#333;}.cls-5{fill:#998675;}.cls-6{fill:#c7b299;}.cls-7{fill:#333;}.cls-3{stroke:#4d4d4d;}.cls-4{stroke:#a67c52;stroke-width:7px;}.cls-8{fill:#1a1a1a;}.cls-9{fill:#f2f2f2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 92.29,
    cy: 214.53,
    rx: 92.29,
    ry: 13.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 173,
    cy: 220.21,
    rx: 83,
    ry: 19.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.26,7.39c-9.46,11.94-20.68,26.28-20.8,25.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156,4.32c-6.54,13.14-14.9,29.95-14.96,29.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.4,2.19c-3.37,13.84-8.42,32.09-8.42,32.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.43,1c-.11,13.7-1.75,31.41-1.75,31.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.05,1.1c2.45,14.68,3.38,33.37,3.38,33.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.96,139.82c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.23,136.76c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.09,133.39c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.36,130.33c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.8,126.62c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.07,123.56c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.51,119.85c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.78,116.79c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.29,111.74c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.56,108.68c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.42,103.68c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.69,100.62c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,95.62c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.82,92.56c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.68,87.56c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.95,84.5c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.45,80.44c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.72,77.38c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.64,72.02c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.91,68.96c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.84,63.61c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.11,60.55c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.03,55.19c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.3,52.14c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.58,45.84c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.85,42.79c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.77,37.43c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.04,34.37c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.81,26.44c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.08,23.38c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.84,15.44c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.11,12.38c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.39,6.09c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.66,3.03c4.51,13.48,11.83,28.02,11.83,28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.45,34.48c-5.55,32.23-17.04,70.48-40.58,109.9-14.33,24-30.65,44.28-46.85,61.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.24,35.4c-12.87,6.34-28.79,11.53-28.79,11.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.08,30.37c-12.87,6.34-28.79,11.53-28.79,11.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.57,26.27c-12.87,6.34-28.79,11.53-28.79,11.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M172.05,22.18c-12.87,6.34-28.79,11.53-28.79,11.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.19,14.67c-12.67,8.03-26.76,19.79-26.76,19.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.22,11.03c-10.01,8.82-22.17,21.21-24.41,20.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.54,159.96c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.58,156.06c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.75,150.68c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.79,146.78c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.7,141.05c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.74,137.14c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.25,131.7c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.29,127.79c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.95,122.48c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.99,118.57c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.82,112.67c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.86,108.76c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.3,103.67c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.34,99.77c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.78,94.68c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.82,90.77c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.69,86.84c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.73,82.94c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.17,77.85c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.21,73.95c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.43,69.08c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.47,65.18c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.69,60.31c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.73,56.41c-14.83,6.14-33.29,10.9-33.29,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.99,52.03c-14.17,6.31-31.76,11.32-31.76,11.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.09,48.17c-14.17,6.31-31.76,11.32-31.76,11.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.07,43.35c-12.87,6.34-28.79,11.53-28.79,11.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.26,39.68c-12.87,6.34-28.79,11.53-28.79,11.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "75.5 176.99 73.27 177.22 67.99 182.7 60.92 192.85 51.99 202.3 50.76 216.81 60.05 206.43 79.33 183.8 75.5 176.99"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148,173.38l-21,13c-13,10-4,36,22.01,37.14h60.03c21.96-.14,38.96-21.14,23.96-37.14l-22-13c7-27-68-31-63,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M147,162.38c-1,15,14.14,15.14,31.81,15.14s34.19-1.14,32-15.07c-1.29-8.22-14.33-15.07-32-15.07s-31.26,6.7-31.81,15Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 178.43,
    cy: 159.09,
    rx: 32,
    ry: 11.57
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 178.93,
    cy: 158.52,
    rx: 23.5,
    ry: 7
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M132,185.38l-3.53,2.35c-2.96,1.97-6.88,7.12-6.47,10.65,1,8.49,9.99,18.49,16.03,20.78,.43,.16,6.51,2.22,6.97,2.22h9c.73,0,24.39,.41,25,0,4.1-2.74-3.27-12.71-6.32-20.94-1.03-2.78-3.71-12.06-6.68-12.06h-4c-3.18,0-8.62-1.88-11-4-8.64-7.7-2.97-8.02-8-5-.37,.22-10.65,5.76-11,6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M136.94,196.78c.2,.06,.35,.17,.45,.35,.11,.18,.13,.37,.07,.56-.06,.2-.18,.35-.37,.45-.51,.28-1.07,.57-1.69,.87-.62,.3-1.45,.65-2.48,1.06-1.03,.4-2.04,.65-3.03,.75-.99,.1-1.8,0-2.44-.3-.41-.19-.75-.45-1.01-.79-.31-.45-.35-1.06-.13-1.82,.23-.76,.65-1.58,1.29-2.44,.63-.86,1.22-1.61,1.78-2.24,.55-.64,1.13-1.26,1.75-1.87,.14-.15,.31-.22,.51-.22,.2,0,.37,.07,.52,.21,.1,.09,.16,.21,.2,.34,.03,.13,.03,.26,0,.37-.03,.12-.1,.23-.2,.35-.93,.93-1.77,1.89-2.54,2.86s-1.3,1.75-1.6,2.35c-.3,.59-.42,1.01-.36,1.24,.48,.64,1.61,.71,3.39,.21,1.79-.5,3.55-1.24,5.29-2.22,.19-.1,.38-.12,.58-.07Zm-4.13-7.81c-.33-.15-.47-.41-.42-.76,0-.21,.09-.38,.25-.5,.16-.12,.35-.18,.56-.18,.04,.02,.11,.03,.22,.03s.21,0,.33,.01c.12,0,.22,0,.33,.01,.1,0,.24,0,.4,0l-.07,1.52c-.74-.04-1.19-.07-1.36-.1-.08,.01-.15,0-.23-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M143.68,206.16c.19,.09,.32,.23,.39,.42,.06,.19,.05,.38-.03,.57-.08,.18-.23,.31-.43,.38-.94,.32-1.75,.32-2.43,0-.33-.15-.58-.39-.77-.71-.19-.3-.27-.71-.23-1.22,.04-.51,.12-.96,.24-1.35,.12-.39,.31-.96,.56-1.71,.48-1.33,.7-2.15,.67-2.44-.53-.08-2.26,.59-5.19,2-1.06,.52-1.84,.88-2.33,1.07-.49,.2-.88,.29-1.16,.29-.28,0-.49-.13-.63-.38-.14-.25-.14-.5,0-.74,.67-1.15,2.8-3.94,6.38-8.37,.14-.15,.31-.23,.51-.26,.2-.03,.38,.02,.55,.15,.17,.12,.26,.29,.28,.5,.02,.21-.03,.39-.15,.55-1.71,2.08-3.35,4.16-4.91,6.26,.22-.11,.49-.25,.83-.43,2-.96,3.49-1.6,4.48-1.91,.99-.32,1.74-.31,2.25,.02,.25,.16,.43,.38,.54,.64,.1,.26,.11,.6,.03,1.04-.08,.43-.17,.8-.25,1.12-.09,.31-.24,.78-.46,1.41-.62,1.76-.87,2.76-.72,3.01,.08,.13,.28,.19,.59,.18,.31,0,.6-.06,.88-.14,.17-.06,.35-.05,.54,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M156.9,208.96c.18,.08,.31,.22,.39,.41,.08,.19,.07,.38-.01,.56-.08,.19-.23,.31-.43,.38-1.49,.58-3.26,.91-5.32,.98s-3.79-.31-5.21-1.16c-1.16-.7-1.95-1.69-2.37-2.96-.66,.75-1.19,1.52-1.62,2.28,0,.02-.02,.05-.04,.09v.03c-.28,.42-.59,.56-.95,.42-.04-.02-.07-.03-.09-.04-.16-.07-.27-.19-.35-.34-.08-.16-.1-.33-.06-.52,.04-.14,.17-.38,.37-.71,.41-.73,1.22-1.95,2.44-3.67,1.22-1.72,2.58-3.52,4.09-5.41,.05-.05,.1-.11,.15-.18,1.65-2.04,3.24-3.88,4.77-5.55,1.53-1.66,3.15-3.21,4.85-4.65,1.7-1.44,3.17-2.37,4.4-2.81,1.21-.43,2.23-.44,3.08-.02,.52,.24,.79,.62,.81,1.15,.02,.67-.57,1.58-1.78,2.74-1.21,1.16-2.8,2.41-4.79,3.76-1.99,1.35-3.79,2.53-5.4,3.55s-3.26,2.01-4.95,2.96c-.67,.84-1.34,1.7-2,2.57,1.67-.76,3.46-1.07,5.37-.94,.39,.02,.79,.06,1.18,.12,.21,.05,.38,.16,.49,.32,.11,.16,.16,.34,.14,.54-.04,.14-.1,.27-.17,.36-.07,.1-.17,.17-.29,.22-.13,.05-.26,.06-.39,.05-.28-.06-.56-.09-.83-.1-2.62-.23-5.01,.62-7.17,2.54,.09,.66,.3,1.23,.62,1.71,.31,.49,.74,.89,1.28,1.21,1.22,.75,2.76,1.08,4.61,.97,1.85-.11,3.39-.4,4.61-.86,.2-.07,.39-.07,.57,.02Zm5.53-21.45c-2.54,.92-6.1,4.02-10.68,9.3,2.16-1.33,4.16-2.61,5.97-3.85,1.82-1.24,3.34-2.36,4.56-3.37,1.22-1.01,1.88-1.74,2-2.18-.47-.2-1.09-.16-1.84,.1Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkwell);
export default __webpack_public_path__ + "static/media/inkwell.a405534806f64290b1f5a6bfcfed6c0f.svg";
export { ForwardRef as ReactComponent };